<ng-container *ngIf="isOpen$ | async">
  <ng-container *ngIf="notifications$ | async as notifications">
    <ng-container *ngIf="notifications.length; else noNotifications">
      <div class="notifications" *ngFor="let notification of notifications">
        <hr class="notifications-divider" />
        <fgbcl-notification-item
          [notification]="notification"
          (goToNotification)="goToNotification.emit()"
        ></fgbcl-notification-item>
      </div>
      <div class="row no-gutters px-3 py-1 pagination">
        <div class="col-6">
          <a class="decrement-page fw-bold font-size-14" (click)="decrementPage()" *ngIf="showPrev$ | async">{{
            'notification.previous.page' | translate
          }}</a>
        </div>
        <div class="col-6 text-end">
          <a class="increment-page fw-bold font-size-14" (click)="incrementPage()" *ngIf="showNext$ | async">{{
            'notification.next.page' | translate
          }}</a>
        </div>
      </div>
    </ng-container>
    <ng-template #noNotifications>
      <p class="m-2 text-center">{{ 'notification.no.available.at.the.moment' | translate }}</p>
    </ng-template>
  </ng-container>
</ng-container>
